export default __webpack_public_path__ + "static/media/sun.7c810cd4.svg";